/* Black Friday Lista VIP (page.black-friday-vip / -obrigado): formulário (Klaviyo + cliente Shopify) e FAQ.
   Mesmo sistema da LP Hair Up Brownie (pa-hub-landing.js); aqui só há e-mail e, no fim, segue para a página de obrigado.
   Carregado uma vez em layout/theme.liquid; o guard evita correr duas vezes. */
(function () {
  if (window.BF_LANDING) return;

  var EMAIL_RE = /^\S+@\S+\.\S+$/;
  var LOG = '[BF Lista VIP]';

  function each(root, selector, fn) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), fn);
  }

  function once(el, key) {
    if (el.dataset[key]) return false;
    el.dataset[key] = '1';
    return true;
  }

  /* Formulário */
  function initSignup(root) {
    if (!once(root, 'bfReady')) return;
    var copy = JSON.parse(root.querySelector('[data-bf-copy]').textContent);
    var form = root.querySelector('[data-bf-form]');
    var input = root.querySelector('[data-bf-email]');
    var tipEl = root.querySelector('[data-bf-tip]');
    var error = root.querySelector('[data-bf-error]');
    var submit = root.querySelector('[data-bf-submit]');
    var success = root.querySelector('[data-bf-success]');

    function tip(msg) {
      tipEl.textContent = msg || '';
      tipEl.hidden = !msg;
      input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    input.addEventListener('input', function () { tip(''); });
    // Liga já o captcha do cliente Shopify, para estar pronto quando a pessoa submeter
    input.addEventListener('focus', function () { bindShopifyCaptcha(root); }, { once: true });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input.value.trim();
      tip('');
      error.hidden = true;
      if (!email || !EMAIL_RE.test(email)) {
        tip(email ? copy.errorEmail : copy.errorEmailEmpty);
        input.focus();
        return;
      }
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');

      // A Klaviyo decide o sucesso; o cliente Shopify é um extra que não bloqueia a inscrição,
      // mas esperamos por ele (com limite) antes de sair da página, senão o envio para o iframe é cortado.
      subscribe(root.dataset, email).then(function () {
        var extra;
        try { extra = shopifyCustomer(root, root.dataset, email); } catch (err) { console.warn(LOG, 'Shopify:', err); }
        var next = root.dataset.thankYouUrl;
        if (next) {
          // Com página de obrigado: espera pelo Shopify (com limite) antes de sair, senão o envio para o iframe é cortado
          return Promise.resolve(extra).then(function () { window.location.assign(next); });
        }
        // Sem página de obrigado: o cartão aparece logo e o cliente Shopify termina em fundo (a página não sai)
        form.hidden = true;
        success.hidden = false;
        success.querySelector('[data-bf-success-title]').focus();
      }, function (err) {
        console.error(LOG, 'Klaviyo:', err);
        error.textContent = copy.errorNetwork;
        error.hidden = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      });
    });
  }

  // Klaviyo Client Subscriptions API (single opt-in), idioma da página no perfil
  function subscribe(cfg, email) {
    var key = (cfg.klaviyoKey || '').trim();
    var list = (cfg.klaviyoList || '').trim();
    var properties = {
      idioma: cfg.lang || 'pt',
      source: cfg.source || 'LP Black Friday VIP'
    };
    if (!key || !list) {
      console.warn(LOG, 'Klaviyo sem public key ou sem list ID nas settings da secção: modo de teste, nada foi enviado.', { email: email, properties: properties });
      return Promise.resolve();
    }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: properties.source,
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: properties,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: list } } }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': cfg.klaviyoRevision || '2026-07-15'
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
    });
  }

  // Cliente no Shopify pelo formulário de newsletter nativo (form_type=customer). Nunca por fetch: o captcha da
  // loja (captcha-bootstrap/hCaptcha) dá 403. O captcha só liga o form depois de um focusin, por isso ligamo-lo
  // quando a pessoa foca o e-mail e, no envio, esperamos pelo data-hcaptcha-bound antes de submeter para o iframe.
  function shopifyForm(root) { return root.querySelector('form[id^="bf-shopify-form-"]'); }

  function bindShopifyCaptcha(root) {
    var sf = shopifyForm(root);
    if (!sf || sf.hasAttribute('data-hcaptcha-bound') || sf.dataset.bfBinding) return;
    sf.dataset.bfBinding = '1';
    sf.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
  }

  function whenBound(sf, timeout) {
    return new Promise(function (resolve) {
      var start = Date.now();
      (function check() {
        if (sf.hasAttribute('data-hcaptcha-bound')) return resolve(true);
        if (Date.now() - start > timeout) return resolve(false);
        setTimeout(check, 150);
      })();
    });
  }

  // Devolve uma promessa que resolve quando o Shopify responde (ou ao fim de um limite), para poder sair da página
  function shopifyCustomer(root, cfg, email) {
    var ready = (cfg.klaviyoKey || '').trim() && (cfg.klaviyoList || '').trim();
    var sf = shopifyForm(root);
    var sink = root.querySelector('iframe[name^="bf-shopify-sink-"]');
    if (!ready || !sf || !sink) return null;
    var lang = /^(pt|es|en|de|nl)$/.test(cfg.lang) ? cfg.lang : 'pt';
    var tags = ['lang_' + lang];
    if (cfg.shopifyTag) tags.push(cfg.shopifyTag);
    sf.querySelector('[data-bf-shopify-email]').value = email;
    sf.querySelector('[data-bf-shopify-tags]').value = tags.join(', ');
    sf.target = sink.name;

    return new Promise(function (resolve) {
      var limit = setTimeout(function () {
        console.warn(LOG, 'O Shopify não respondeu a tempo: segue sem confirmar o cliente (Klaviyo OK).');
        resolve();
      }, 8000);
      sink.addEventListener('load', function onLoad() {
        sink.removeEventListener('load', onLoad);
        clearTimeout(limit);
        var url = '';
        try { url = sink.contentWindow.location.href; } catch (e) {}
        if (/customer_posted=true/.test(url)) console.info(LOG, 'Cliente Shopify criado/atualizado.');
        else console.warn(LOG, 'Shopify não confirmou o cliente (Klaviyo OK). Resposta:', url);
        resolve();
      });
      bindShopifyCaptcha(root);
      whenBound(sf, 5000).then(function (bound) {
        if (!bound) {
          clearTimeout(limit);
          console.warn(LOG, 'O captcha da Shopify não ficou pronto: cliente não criado no Shopify (Klaviyo OK).');
          resolve();
          return;
        }
        // requestSubmit dispara o submit que o hCaptcha interceta (verificação invisível) antes de enviar para o iframe
        if (sf.requestSubmit) sf.requestSubmit(); else sf.submit();
      });
    });
  }

  /* FAQ: um aberto de cada vez */
  function initFaq(root) {
    if (!once(root, 'bfReady')) return;
    var items = root.querySelectorAll('[data-bf-faq-item]');
    function set(item, open) {
      item.classList.toggle('is-open', open);
      item.querySelector('[data-bf-faq-q]').setAttribute('aria-expanded', open ? 'true' : 'false');
      item.querySelector('[data-bf-faq-a]').hidden = !open;
    }
    Array.prototype.forEach.call(items, function (item) {
      item.querySelector('[data-bf-faq-q]').addEventListener('click', function () {
        var open = !item.classList.contains('is-open');
        Array.prototype.forEach.call(items, function (other) { set(other, false); });
        set(item, open);
      });
    });
  }

  function init(root) {
    root = root || document;
    each(root, '[data-bf-signup]', initSignup);
    each(root, '[data-bf-faq]', initFaq);
  }

  window.BF_LANDING = { init: init };
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
})();
